import { render, staticRenderFns } from "./home.vue?vue&type=template&id=54913eb7"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style1 from "./home.vue?vue&type=style&index=1&id=54913eb7&prod&lang=less&scope=true"
import style2 from "./home.vue?vue&type=style&index=2&id=54913eb7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports